module.exports = __webpack_public_path__ + "static/alexwork7-13d130c9e13e080a79a0ee943364e884.jpg";